import { CommonModule } from '@angular/common';
import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormSaveAddressService } from './service/form-save-address.service';

import { Subscription } from 'rxjs';
import { LoaderMinimalGeneralComponent } from '../../loader-minimal-general/loader-minimal-general.component';
import { LoaderMinimalGeneralService } from '../../loader-minimal-general/service/loader-minimal-general.service';
import { ModalViewLocationService } from '../service/modal-view-location.service';

@Component({
  selector: 'modal-view-location-form-save-address',
  templateUrl: './form-save-address.component.html',
  styles: [''], // Change to inline styles instead of styleUrls
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoaderMinimalGeneralComponent]
})
export class FormSaveAddressComponent implements OnInit, OnDestroy {
  addressForm: FormGroup;
  addressDetail: string = '';
  addressName: string = '';
  isLoading: boolean = false;
  private subscription: Subscription = new Subscription();
  @Output() saveAddress = new EventEmitter<any>();

  constructor(private fb: FormBuilder,
    private formSaveAddressService: FormSaveAddressService,
    private loaderService: LoaderMinimalGeneralService,
    public modalViewLocationService: ModalViewLocationService,
  ) {
    // Patrón para permitir solo letras y números (incluyendo espacios)
    const alphanumericPattern = /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s]+$/;

    this.addressForm = this.fb.group({
      addressName: [
        this.modalViewLocationService.isEditMode?this.modalViewLocationService.editableAddress.ad_name:
        '', [
        Validators.required,
        Validators.pattern(alphanumericPattern)
      ]],
      addressDetail:[
        this.modalViewLocationService.isEditMode?this.modalViewLocationService.editableAddress.ad_reference:
        '', [
        Validators.pattern(alphanumericPattern)
      ]]
    });
  }

  ngOnInit(): void {
    this.subscription.add(
      this.loaderService.loading$.subscribe(loading => {
        this.isLoading = loading;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.addressForm.get(fieldName);
    return field ? (field.invalid && (field.dirty || field.touched)) : false;
  }

  onSubmit(): void {
    if (this.addressForm.valid) {
      this.loaderService.showLoader();
      this.saveAddress.emit(this.addressForm.value);
      // console.log('formulario', this.addressForm.value);
      this.formSaveAddressService.reference = this.addressForm.value.addressDetail
      // console.log('reference', this.formSaveAddressService.reference);

      this.formSaveAddressService.name = this.addressForm.value.addressName
      this.formSaveAddressService.saveLocation();
    } else {
      // Marcar todos los campos como tocados para mostrar los errores
      Object.keys(this.addressForm.controls).forEach(key => {
        const control = this.addressForm.get(key);
        control?.markAsTouched();
      });
    }
  }
}
